export const LoaderSpinner = () => (
  <div className="lds-ring">
    <div />
    <div />
    <div />
    <div />
  </div>
);
